module.exports = __webpack_public_path__ + "img/round-brilliant.0a119e00.svg";